import { useContext } from "react";

import { Grid, Switch, FormControlLabel, Checkbox } from "@material-ui/core";

import TextField from "../../../../components/basics/TextFieldErp";
import Fieldset from "../../../../components/basics/Fieldset";
import Chip from "../../../../components/basics/Chip";
import {
  HeaderAccordion,
  Line,
  CheckItem,
  Form,
} from "../styles/MotivoCancelamento";
import Card from "../../../../components/cards/Card";

import { MotivoCancelamentoContext } from "../context/MotivoCancelamentoContext";

import useMotivoCancelamentoController from "../controllers/MotivoCancelamentoController";

const AccordionDadosGerais = ({ ...props }) => {
  const {
    description,
    setDescription,
    released,
    setReleased,
    errorsSubmit,
    companies,
  } = useContext(MotivoCancelamentoContext);

  const { handleCheckCompany } = useMotivoCancelamentoController();

  return (
    <>
      <Fieldset
        titulo={
          <HeaderAccordion>
            <Grid container spacing={2}>
              <Grid item xs>
                <Chip
                  label="DADOS GERAIS"
                  bgcolor="primary"
                  textcolor="white"
                />
              </Grid>
            </Grid>
          </HeaderAccordion>
        }
        bgcolor="white"
        textcolor="black"
        accordion
        defaultExpanded
      >
        <Line container spacing={1}>
          <Grid container spacing={4}>
            <Grid item xs={6}>
              <TextField
                label="Descrição *"
                value={description}
                setValue={setDescription}
                size="small"
                error={!!errorsSubmit?.description}
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                label="Ativo"
                value="end"
                control={
                  <Switch
                    checked={released}
                    onChange={() => setReleased((current) => !current)}
                    color="primary"
                    onClick={(event) => event.stopPropagation()}
                    onFocus={(event) => event.stopPropagation()}
                  />
                }
              />
            </Grid>
          </Grid>
        </Line>

        {companies.length > 1 && (
          <Line container spacing={1}>
            <Card line="left" padding="10" fullWidth>
              <Grid container>
                <Chip title="Empresas" label="Empresas" bgcolor="secondary" />
              </Grid>
              <Grid container>
                <Form>
                  {companies.map((company) => (
                    <CheckItem
                      key={company.id}
                      control={
                        <Checkbox
                          checked={company.check}
                          onChange={() => {
                            handleCheckCompany(company.id);
                          }}
                        />
                      }
                      label={company.apelido}
                    />
                  ))}
                </Form>
              </Grid>
            </Card>
          </Line>
        )}
      </Fieldset>
    </>
  );
};

export default AccordionDadosGerais;
